<div class="container-fluid ac-poppins mt-4" *ngIf="!isNewPaymentExperienceEnabled">
    <div class="loader" *ngIf="this.aciPaymentService.showLoader"></div>
    <div class="row mb-4">
        <div class=" d-sm-flex">
            <div class="me-auto" style="align-items: center;display: -webkit-inline-box;">
            </div>
            <app-bans-dropdown [banCAs]="banCAs" [ban]="ban" (selectedBAN)="selectBan($event)"></app-bans-dropdown>

        </div>
    </div>
    <div *ngIf="!this.aciPaymentService.showLoader">
    <div class="row">
            <div class="col-lg-6 mt-3">
                <div class=" fs-14">
                    <table class="table mb-4 dataTable table-striped-custom table-bordered-custom" id="example5">
                        <thead class="ac-btb">
                            <tr>
                                
                                <th class="" scope="col">Status</th>
                                <th class="" scope="col" >Account No</th>
                                <th class="" scope="col">Payment Method</th>
                                <th class="" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody class="ac-rowhov">
    
                            <tr class="ac-table-hover-row align-middle" *ngFor="let bans of recurringSchedule | keyvalue; index as i">
                                <td><span class="text-black font-w500 ac-invoice-num"></span>
                                    <div class="checkbox me-0 align-self-center">
                                        <div class="custom-control">
                                            <input type="checkbox" [disabled]="isRecurringFlagDisable || !isPaymentMethodAvailable" [(ngModel)]="bans.value.isRecurring && isPaymentMethodAvailable" (click)="changeRecurring(bans.value)" (ngModelChange)="openConfirmation()" class="custom-checkbox custom-control-input">
                                            <label class="custom-control-label"></label>
                                        </div>
                                    </div></td>
                                <td><span class="text-black font-w500 ac-invoice-num">{{bans.key}}</span></td>
                                <td><span class="text-black font-w500 ac-invoice-num">
                                    <div ngbDropdown class="mySelectArrowCard">
                                    <button class="btn btn-outline-secondary" id="dropdownPriority" ngbDropdownToggle *ngIf="bans.value.defaultPaymentMethodId">
                                      {{ bans.value.defaultPaymentMethodId}}
                                    </button>
                                    <button class="btn btn-outline-secondary" id="dropdownPriority" ngbDropdownToggle *ngIf="!bans.value.defaultPaymentMethodId">
                                        NA
                                      </button>
                
                                    <div ngbDropdownMenu aria-labelledby="dropdownPriority">
                                        <ng-container >
                                            <button class="dropdown-item"><a (click)="showIframe()">Select payment method</a></button>
                                        </ng-container>
                                 
                                    </div>
                                  </div></span>
                                </td>
                               
                            </tr>
    
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 order-md-1 mb-4" *ngIf="showPaymentMethods">
            <iframe #myDiv id="my_iframe1" [src]="url" width="100%" height="100%" target="_parent" frameborder="0"  cellspacing="0" class="ac-speedpayiframe"
style="border-style: none;background-color: #ffffff!important;height:65rem" allowfullscreen >
</iframe>
        </div>
    </div>
   
</div>

